<template>
  <!--
    공용 다이얼로그 — 앱 전체 다이얼로그 룩앤필 통일(디자인 시스템 표준).
    기준(불변): dim 테마반응(다크 0.6 / 라이트 0.75) · overlay-color #000 · 카드 rounded="xl"
    - title 있으면 제목 + 구분선 자동 (closable=true면 우측 X 닫기)
    - #header 슬롯: 커스텀 헤더(있으면 title 대신 렌더)
    - 본문: 기본 slot (flush=true면 패딩 없는 풀바디)
    - 액션: #actions slot (v-spacer 내장)
  -->
  <v-dialog
    :value="value"
    :max-width="width ? undefined : maxWidth"
    :width="width"
    :persistent="persistent"
    :scrollable="scrollable"
    :content-class="contentClass"
    overlay-color="#000"
    :overlay-opacity="$vuetify.theme.dark ? 0.6 : 0.75"
    @input="$emit('input', $event)"
  >
    <!-- activator 슬롯 패스스루(버튼으로 여는 다이얼로그 지원) -->
    <template v-if="$scopedSlots.activator" v-slot:activator="slotProps">
      <slot name="activator" v-bind="slotProps"></slot>
    </template>

    <v-card rounded="xl">
      <slot name="header">
        <template v-if="title">
          <v-card-title class="d-flex align-center text-subtitle-1 font-weight-bold">
            <span>{{ title }}</span>
            <v-spacer v-if="closable"></v-spacer>
            <v-btn v-if="closable" icon small @click="$emit('input', false)">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
        </template>
      </slot>

      <v-card-text v-if="!flush" class="pt-4 pb-2">
        <slot></slot>
      </v-card-text>
      <slot v-else></slot>

      <v-card-actions v-if="$slots.actions">
        <v-spacer></v-spacer>
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BaseDialog",
  props: {
    value: { type: Boolean, default: false }, // v-model
    title: { type: String, default: "" },
    maxWidth: { type: [String, Number], default: 320 },
    width: { type: [String, Number], default: null }, // max-width 외 width 직접 지정용
    persistent: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: false }, // 긴 본문 스크롤
    closable: { type: Boolean, default: false }, // 제목줄 우측 X 닫기 버튼
    flush: { type: Boolean, default: false }, // 본문 패딩 제거(풀바디 레이아웃)
    contentClass: { type: String, default: "" },
  },
};
</script>
